/**
 * vtkImageData volume resample helper
 *
 * Resample a vtkImageData to desired spacing
 */

import type vtkImageData from '@kitware/vtk.js/Common/DataModel/ImageData';
import { InterpolationMode } from '@kitware/vtk.js/Imaging/Core/AbstractImageInterpolator/Constants';
import vtkImageReslice from '@kitware/vtk.js/Imaging/Core/ImageReslice';

/**
 * Resample a volume to a desired spacing
 * @param volume volume to resample
 * @param targetSpacing desired output spacing
 * @returns resampled volume
 */
export function resampleVolumeToSpacing(
    volume: vtkImageData,
    targetSpacing: [number, number, number]
): vtkImageData {
    const imageReslice = vtkImageReslice.newInstance();

    imageReslice.setInputData(volume);
    imageReslice.setOutputSpacing(targetSpacing);
    imageReslice.setInterpolationMode(InterpolationMode.LINEAR);
    imageReslice.setAutoCropOutput(true);

    imageReslice.update();

    const resampledVolume = imageReslice.getOutputData();

    imageReslice.delete();

    return resampledVolume;
}
